module.exports = __webpack_public_path__ + "img/ucoin_logo.fc6bf33d.png";